import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    questionTypeListLoading: false,
    questionTypeListSuccess: null,
    questionTypeListError: '',

    getQuestionTypeLoading: false,
    getQuestionTypeSuccess: null,
    getQuestionTypeError: '',

    createQuestionTypeLoading: false,
    createQuestionTypeSuccess: {},
    createQuestionTypeError: '',
}

export const questionTypeSlice = createSlice({
    name: 'questionType',
    initialState, 
    reducers: {
        setQuestionTypeListLoading: (state) => {
            state.questionTypeListLoading = true;
            state.questionTypeListSuccess = null;
            state.questionTypeListError = '';
        },
        setQuestionTypeListSuccess: (state, action) => {
            state.questionTypeListLoading = false;
            state.questionTypeListSuccess = action.payload;
            state.questionTypeListError = '';
        },
        setQuestionTypeListError: (state, action) => {
            state.questionTypeListLoading = false;
            state.questionTypeListSuccess = null;
            state.questionTypeListError = action.payload;
        },
        setGetQuestionTypeLoading: (state) => {
            state.getQuestionTypeLoading = true;
            state.getQuestionTypeSuccess = {};
            state.getQuestionTypeError = '';
        },
        setGetQuestionTypeSuccess: (state, action) => {
            state.getQuestionTypeLoading = false;
            state.getQuestionTypeSuccess = action.payload;
            state.getQuestionTypeError = '';
        },
        setGetQuestionTypeError: (state, action) => {
            state.getQuestionTypeLoading = false;
            state.getQuestionTypeSuccess = {};
            state.getQuestionTypeError = action.payload;
        },
        setCreateQuestionTypeLoading: (state) => {
            state.createQuestionTypeLoading = true;
            state.createQuestionTypeSuccess = {};
            state.createQuestionTypeError = '';
        },
        setCreateQuestionTypeSuccess: (state, action) => {
            state.createQuestionTypeLoading = false;
            state.createQuestionTypeSuccess = action.payload;
            state.createQuestionTypeError = '';
        },
        setCreateQuestionTypeError: (state, action) => {
            state.createQuestionTypeLoading = false;
            state.createQuestionTypeSuccess = {};
            state.createQuestionTypeError = action.payload;
        },
        resetDetails: (state) => {
            state.getQuestionTypeSuccess = {};
            state.createQuestionTypeSuccess = {};
        },
    }
})

export const { setQuestionTypeListLoading, setQuestionTypeListSuccess, setQuestionTypeListError,
    setGetQuestionTypeLoading, setGetQuestionTypeSuccess, setGetQuestionTypeError, 
    setCreateQuestionTypeLoading, setCreateQuestionTypeSuccess, setCreateQuestionTypeError,
    resetDetails
} = questionTypeSlice.actions;


export default questionTypeSlice.reducer;